export function accentFold(str = '') {
  if (typeof String.prototype.normalize !== 'function') {
    // odeniel si IE11:
    return _accentFold_IE11(str);
  }
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

function _accentFold_IE11(str = '') {
  const REGEXP_a = new RegExp(/[àáâãäå]/g);
  const REGEXP_A = new RegExp(/[ÀÁÂÃÄÅ]/g);
  const REGEXP_c = new RegExp(/[ç]/g);
  const REGEXP_C = new RegExp(/[Ç]/g);
  const REGEXP_e = new RegExp(/[èéêë]/g);
  const REGEXP_E = new RegExp(/[ÈÉÊË]/g);
  const REGEXP_i = new RegExp(/[ìíîï]/g);
  const REGEXP_I = new RegExp(/[ÌÍÎÏ]/g);
  const REGEXP_n = new RegExp(/ñ/g);
  const REGEXP_N = new RegExp(/Ñ/g);
  const REGEXP_o = new RegExp(/[òóôõö]/g);
  const REGEXP_O = new RegExp(/[ÒÓÔÕÖ]/g);
  const REGEXP_u = new RegExp(/[ùúûü]/g);
  const REGEXP_U = new RegExp(/[ÙÚÛÜ]/g);
  const REGEXP_y = new RegExp(/[ýÿ]/g);
  const REGEXP_Y = new RegExp(/[ÝŸ]/g);
  const REGEXP_ae = new RegExp(/[æ]/g);
  const REGEXP_oe = new RegExp(/[œ]/g);
  return str
    .replace(REGEXP_a, 'a')
    .replace(REGEXP_A, 'A')
    .replace(REGEXP_c, 'c')
    .replace(REGEXP_C, 'C')
    .replace(REGEXP_e, 'e')
    .replace(REGEXP_E, 'E')
    .replace(REGEXP_i, 'i')
    .replace(REGEXP_I, 'I')
    .replace(REGEXP_n, 'n')
    .replace(REGEXP_N, 'N')
    .replace(REGEXP_o, 'o')
    .replace(REGEXP_O, 'O')
    .replace(REGEXP_u, 'u')
    .replace(REGEXP_U, 'U')
    .replace(REGEXP_y, 'y')
    .replace(REGEXP_Y, 'Y')
    .replace(REGEXP_ae, 'ae')
    .replace(REGEXP_oe, 'oe');
}
